import { createFileRoute } from "@tanstack/react-router";
import { Black2x1Page } from "@/components/black2x1/Black2x1Page";
import logoBlackOficial from "@/assets/black2x1/black-logo-oficial.webp.asset.json";

const URL = "https://fisioemortopedia.com.br/black-oferta-cbfeo";
const TITLE = "BLACK EM DOBRO · Oferta para participantes do CBFEO | FEO";
const DESC = "Oferta exclusiva para participantes do CBFEO: duas pós-graduações e acesso vitalício à Star Cursos com condição especial na BLACK EM DOBRO.";

export const Route = createFileRoute("/black-oferta-cbfeo")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { property: "og:image", content: logoBlackOficial.url },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
      { name: "twitter:image", content: logoBlackOficial.url },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: logoBlackOficial.url, fetchPriority: "high" },
    ],
  }),
  component: () => <Black2x1Page mode="oferta" variant="cbfeo" />,
});